import React from "react";
import { connect } from 'react-redux'

import Menu from '../utils/menu/Menu';

import './Help.css';

class Help extends React.Component {

    render() {

        return (
            <div className="equipment">
                <Menu options={[
                        { shortcut: '↑←↓→', text: ' Move selectors' },
                        { shortcut: 'j', text: ' Talk to town' },
                        { shortcut: 'SHIFT + j', text: ' Command' },
                        { shortcut: 'i', text: ' Inventory' },
                        { shortcut: 'a', text: ' Name location' },
                        // { shortcut: 'p', text: ' Profile' },
                        { shortcut: 'l', text: ' Look' },
                        { shortcut: 'q', text: ' Equipment' },
                        { shortcut: 't', text: ' Character sheet' },
                        { shortcut: 'k', text: ' Workshop' },
                        // { shortcut: 'z', text: ' Conversation tree wizard' },
                        { shortcut: 'v', text: ' Events' },
                        // { shortcut: 'y', text: ' Diary' },
                        { shortcut: 'c', text: ' Chat Messages' },
                        { shortcut: 'm', text: ' Move' },
                        { shortcut: 'g', text: ' Gather' },
                        { shortcut: 'w', text: ' Wait' },
                        { shortcut: 'f', text: ' Fight' },
                        { shortcut: 's', text: ' Search Stockpiles' },
                        { shortcut: 'h', text: ' Haul' },
                        { shortcut: 'd', text: ' Drop Items Off' },
                        { shortcut: 'n', text: ' Zone' },
                        { shortcut: 'o', text: ' Organisation' },
                        { shortcut: 'u', text: ' Schedule' },
                        { shortcut: 'x', text: ' Change character' },
                        { shortcut: 'z', text: ' Follow character' },
                        { shortcut: 'e', text: ' Leaderboard' },
                        // { shortcut: '>', text: ' Walk downstairs' },
                        // { shortcut: '<', text: ' Walk upstairs' },
                        { shortcut: 'BACKSPACE', text: ' Stop/cancel current order' },
                        { shortcut: 'SHIFT + BACKSPACE', text: ' Stop/cancel all currently executable orders' },
                        { shortcut: 'ESC', text: ' Close Menu' },
                        { shortcut: '/guide [in chat]', text: ' Open New Player Guide in a new tab' },
                        { shortcut: '/die [in chat]', text: ' Kill character' },
                        { shortcut: '/logout [in chat]', text: ' Logout' },
                        { shortcut: '/discord [in chat]', text: ' Open Discord in new tab' },
                        { shortcut: '/wiki [in chat]', text: ' Open Wiki in new tab' },
                        { shortcut: '/mute-music [in chat]', text: ' Mute the music' },
                        { shortcut: '/unmute-music [in chat]', text: ' Unmute the music' },
                    ]}
                    menuContainer="equipment"
                    // optionChosen={this.onOrganisationChosen.bind(this)}
                />
            </div>
        )
    }
}

const mapToStateProps = state => {
    return {}
}

export default connect(
    mapToStateProps,
    {
        
    }
)(Help);